
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-2ec9b903&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./LiftDetail.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./LiftDetail.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-2ec9b903!../../node_modules/vue-loader/lib/selector?type=template&index=0!./LiftDetail.vue"),
  /* scopeId */
  "data-v-2ec9b903",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/LiftDetail.vue
// module id = 277
// module chunks = 2 3